const AUTH_KEY = "erp_admin_token";

function ok(data, msg = "ok") {
  return { code: 0, msg, data };
}

function fail(msg, code = 4001) {
  return { code, msg, data: null };
}

export function login(payload = {}) {
  const { username, password } = payload;
  if (username !== "admin" || password !== "123456") {
    return fail("账号或密码错误");
  }
  const token = `mock-token-${Date.now()}`;
  localStorage.setItem(AUTH_KEY, token);
  return ok({ token, username: "admin" }, "登录成功");
}

export function logout() {
  localStorage.removeItem(AUTH_KEY);
  return ok(true, "已退出登录");
}

export function profile(headers = {}) {
  const token = headers.Authorization || headers.authorization || localStorage.getItem(AUTH_KEY);
  if (!token) {
    return fail("未登录或登录失效", 4010);
  }
  return ok({ username: "admin", role: "super-admin" });
}
